module.exports = __webpack_public_path__ + "static/media/Getting started video script 3 28 24_1711621030641.97abbf5e.docx";